module.exports = new __parcel__URL__("fur70_chip.053f593c.png").toString();